<h1 matDialogTitle
    translate>
    license_modal_deactivate_offline_title
</h1>

<mat-dialog-content>
    <p translate>license_modal_deactivate_offline_description</p>
    <div class="numbered-list">
        <button mat-mini-fab
                type="button">1</button>
        <div class="instruction-step">
            <p class="instruction-text"
               translate>
                license_modal_deactivate_offline_download_file
            </p>
            <div class="layout-row">
                <mat-form-field>
                    <input [value]="'deactivation_request.txt'"
                           matInput
                           readonly
                           required
                           data-cy="license-file-name-input" />
                </mat-form-field>

                <label #downloadButton>
                    <button (click)="generate()"
                            mat-raised-button
                            color="primary"
                            data-cy="deactivate-offline-generate"
                            type="button">
                        <mat-icon>file_download</mat-icon>
                        <span translate
                              class="text-upper">
                            license_modal_deactivate_offline_download
                        </span>
                    </button>
                </label>
            </div>
        </div>
    </div>
    <div class="numbered-list">
        <button mat-mini-fab
                type="button">2</button>
        <div class="instruction-step">
            <p class="instruction-text">
                {{ 'license_modal_deactivate_offline_step_2' | translate | translateCut: 0 }}
                <a [href]="serviceUrl"
                   target="_blank">
                    {{ serviceUrl }}
                </a>
                {{ 'license_modal_deactivate_offline_step_2' | translate | translateCut: 1 }}
            </p>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button (click)="onClose()"
            mat-dialog-close
            mat-button
            type="button"
            class="btn btn-secondary"
            data-cy="button-close">
        {{ 'modal_action_close' | translate }}
    </button>
</mat-dialog-actions>
